{
  "&": "& ",
  "demo": "هذه نسخة تجريبية من Rehla. لن تعمل الإجراءات التي تُجري تغييرات على البيانات.",
  "agency": {
    "addPhoneNumber": "إضافة رقم هاتف",
    "benefits": {
      "analytics": {
        "description": "تتبع الحجوزات والإيرادات ومؤشرات الأداء في الوقت الفعلي",
        "title": "التحليلات والرؤى"
      },
      "clients": {
        "description": "ابني علاقات دائمة مع عملائك",
        "title": "إدارة العملاء"
      },
      "subtitle": "ابدأ في دقائق ونمّي أعمال السفر الخاصة بك باستخدام أدوات قوية مصممة لوكالات مثل وكالتك",
      "team": {
        "description": "تعاون مع فريقك وحدد الأدوار",
        "title": "إدارة الفريق"
      },
      "title": "ما يمكنك فعله",
      "trips": {
        "description": "أنشئ وأدر الرحلات بسهولة، وحدد الأسعار، وتتبع السعة",
        "title": "تنظيم الرحلات"
      }
    },
    "create": {
      "error": {
        "description": "تعذر إنشاء وكالتك. يرجى المحاولة مرة أخرى.",
        "imageUpload": "فشل رفع الشعار"
      },
      "success": {
        "description": "تم إنشاء الوكالة بنجاح."
      }
    },
    "description": "الوصف",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الوكالات.",
        "title": "لا توجد وكالة تطابق المرشحات"
      },
      "noFilters": {
        "description": "الوكالة التي تبحث عنها غير موجودة أو قد تم حذفها.",
        "title": "الوكالة غير موجودة"
      },
      "title": "الوكالة غير موجودة"
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذه الوكالة. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذه الوكالة. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "logo": {
      "current": {
        "description": "شعار وكالتك الحالي",
        "title": "الشعار الحالي"
      },
      "error": {
        "invalidType": {
          "description": "يرجى اختيار ملفات الصور فقط (JPEG أو PNG أو WebP)",
          "title": "نوع الملف غير صالح"
        }
      },
      "logo": "الشعار",
      "new": {
        "description": "قم برفع شعار وكالتك (الحد الأقصى 10 ميجابايت)",
        "title": "اسحب الشعار هنا أو انقر للاختيار"
      },
      "update": {
        "description": "قم برفع شعار جديد لاستبدال الحالي (الحد الأقصى 10 ميجابايت)",
        "title": "اسحب الشعار الجديد هنا أو انقر للاختيار"
      }
    },
    "name": "اسم الوكالة",
    "new": "وكالة جديدة",
    "phone": "رقم الهاتف",
    "save": "إنشاء وكالة",
    "subtitle": "قم بإعداد ملف وكالتك لبدء إدارة الرحلات والعملاء",
    "title": "إنشاء وكالتك",
    "username": {
      "description": "5 أحرف، أرقام وحروف فقط",
      "error": {
        "usernameAvailable": "اسم المستخدم مستخدم بالفعل"
      },
      "title": "اسم مستخدم الوكالة"
    },
    "website": "الموقع الإلكتروني"
  },
  "all": "الكل",
  "amount": "المبلغ",
  "analytics": {
    "clients": {
      "acquisitionTimeline": "الجدول الزمني لاكتساب العملاء",
      "heavy": "ثقيل",
      "heavyDescription": "6+ حجوزات",
      "light": "خفيف",
      "lightDescription": "0-2 حجوزات",
      "medium": "متوسط",
      "mediumDescription": "3-5 حجوزات",
      "newClients": "جديد",
      "newVsReturning": "العملاء الجدد مقابل العائدين",
      "noOutstandingDues": "لا يوجد عملاء بمستحقات معلقة",
      "outstandingDues": "العملاء ذوو المستحقات المعلقة",
      "returningClients": "عائد",
      "segmentation": "تقسيم العملاء",
      "title": "تحليلات العملاء",
      "topBySpend": "أفضل العملاء حسب الإنفاق"
    },
    "dateRange": {
      "allTime": "كل الأوقات",
      "clearCustom": "مسح النطاق المخصص",
      "custom": "مخصص",
      "customRange": "نطاق مخصص",
      "lastThreeMonths": "آخر 3 أشهر",
      "thisMonth": "الشهر الماضي",
      "thisYear": "العام الماضي"
    },
    "error": {
      "description": "خطأ في تحميل التحليلات. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض التحليلات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "noData": "لا توجد بيانات",
    "overview": {
      "activeTrips": "رحلات نشطة",
      "amountDue": "المبلغ المستحق",
      "newClients": "عملاء جدد",
      "newClientsThisMonth": "عملاء جدد هذا الشهر",
      "overview": "نظرة عامة",
      "totalClients": "إجمالي العملاء",
      "totalRefunds": "إجمالي الاستردادات",
      "totalReservations": "إجمالي الحجوزات",
      "totalRevenue": "إجمالي الإيرادات"
    },
    "payments": {
      "completionRate": "معدل إتمام الدفع",
      "fullyPaid": "مدفوع بالكامل",
      "overpaid": "حجوزات مدفوعة زائد",
      "overrefunded": "حجوزات مستردة زائد",
      "partialPayments": "مدفوعات جزئية",
      "title": "تحليلات المدفوعات",
      "totalDue": "إجمالي المبلغ المستحق",
      "totalPaid": "إجمالي المبلغ المدفوع",
      "totalRefunded": "إجمالي المبلغ المسترد"
    },
    "reservations": {
      "adults": "بالغون",
      "averageRevenue": "متوسط الإيرادات لكل حجز",
      "averageTimeBetweenBookingAndTrip": "متوسط الوقت بين الحجز والرحلة",
      "cancellationRate": "معدل الإلغاء",
      "cancellations": "الإلغاءات",
      "cancelled": "ملغى",
      "cancelledWithRefund": "مع استرداد",
      "cancelledWithoutRefund": "بدون استرداد",
      "children": "أطفال",
      "composition": "تركيبة الحجز",
      "days": "أيام",
      "overTime": "الحجوزات مع مرور الوقت",
      "reservations": "الحجوزات",
      "revenue": "الإيرادات",
      "revenueOverTime": "الإيرادات مع مرور الوقت",
      "statusDistribution": "توزيع الحالة",
      "title": "تحليلات الحجوزات"
    },
    "title": "التحليلات",
    "trips": {
      "accessibilityDistribution": "توزيع إمكانية الوصول",
      "audienceDistribution": "توزيع الجمهور",
      "foodDistribution": "توزيع خيارات الطعام",
      "guidesDistribution": "توزيع المرشدين",
      "lowCapacity": "رحلات بسعة منخفضة",
      "noLowCapacityTrips": "لا توجد رحلات بسعة منخفضة",
      "noTripsStartingSoon": "لا توجد رحلات تبدأ في الثلاثين يوماً القادمة",
      "overbooked": "ممتلئة بالكامل",
      "peakTravelMonths": "أشهر السفر الذروة",
      "remaining": "متبقي",
      "startingSoon": "رحلات تبدأ قريباً",
      "title": "تحليلات الرحلات",
      "topByReservations": "أفضل الرحلات حسب الحجوزات",
      "topByRevenue": "أفضل الرحلات حسب الإيرادات",
      "transportationDistribution": "توزيع وسائل النقل"
    }
  },
  "auditLog": {
    "action": "الإجراء",
    "actions": {
      "CREATE": "أنشأ",
      "DELETE": "حذف",
      "UPDATE": "حدّث"
    },
    "date": "التاريخ",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع سجلات التدقيق.",
        "title": "لا توجد سجلات تدقيق تطابق المرشحات"
      },
      "noFilters": {
        "description": "الإجراءات التي ينفذها المستخدمون ستظهر هنا.",
        "title": "لا توجد سجلات تدقيق بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل سجلات التدقيق. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على إدخالات سجل التدقيق للتصدير.",
        "error": {
          "description": "تعذر تصدير سجل التدقيق إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير سجل التدقيق إلى PDF بنجاح."
        }
      }
    },
    "filters": {
      "action": "الإجراء",
      "dateRange": "النطاق الزمني",
      "model": "الكيان",
      "userType": "نوع المستخدم"
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض سجلات التدقيق. المالكون فقط يمكنهم الوصول إلى هذه الميزة."
    },
    "model": "الكيان",
    "models": {
      "AGENCY": "الوكالة",
      "CLIENT": "عميل",
      "DISCOUNT_CODE": "رمز خصم",
      "EMPLOYEE": "موظف",
      "PAYMENT": "دفعة",
      "RESERVATION": "حجز",
      "ROLE": "دور",
      "TRIP": "رحلة",
      "WITHDRAWAL": "عملية سحب"
    },
    "new": "سجل تدقيق جديد",
    "title": "سجل التدقيق",
    "user": "المستخدم",
    "userTypes": {
      "employee": "موظف",
      "owner": "مالك"
    },
    "viewAll": "عرض الكل"
  },
  "back": "رجوع",
  "cancel": "إلغاء",
  "changeLanguage": "تغيير اللغة",
  "client": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع العملاء.",
        "title": "لا يوجد عميل يطابق المرشحات"
      },
      "noFilters": {
        "description": "العميل الذي تبحث عنه غير موجود أو قد تم حذفه.",
        "title": "العميل غير موجود"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذا العميل. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذا العميل. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "عميل جديد"
  },
  "clients": {
    "client": "عميل",
    "clients": "العملاء",
    "create": {
      "error": {
        "description": "تعذر إنشاء العميل. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم إنشاء العميل بنجاح."
      }
    },
    "detail": {
      "clientInfo": "معلومات العميل",
      "emailVerified": "البريد الإلكتروني مؤكد",
      "phoneVerified": "رقم الهاتف مؤكد",
      "reservations": "الحجوزات",
      "statistics": "الإحصائيات"
    },
    "edit": {
      "edit": "تعديل العميل",
      "error": {
        "description": "تعذر تعديل العميل. يرجى المحاولة مرة أخرى.",
        "phoneExists": "يوجد عميل برقم الهاتف هذا بالفعل"
      },
      "success": {
        "description": "تم تعديل العميل بنجاح."
      }
    },
    "email": "البريد الإلكتروني",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع العملاء.",
        "title": "لا يوجد عملاء يطابقون المرشحات"
      },
      "noFilters": {
        "description": "بمجرد أن يحجز العميل رحلة، سيظهر هنا.",
        "title": "لا يوجد عملاء بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل العملاء. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على عملاء للتصدير.",
        "error": {
          "description": "تعذر تصدير العملاء إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع العملاء إلى PDF بنجاح."
        }
      },
      "button": "تصدير إلى PDF",
      "error": {
        "description": "تعذر تصدير العميل إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير العميل إلى PDF بنجاح."
      }
    },
    "filters": {
      "lastTripDate": "تاريخ آخر رحلة",
      "tags": "العلامات",
      "totalBookings": "إجمالي الحجوزات",
      "totalSpent": "إجمالي الإنفاق"
    },
    "firstTripDate": "أول رحلة",
    "forbidden": {
      "description": "غير مسموح لك بعرض العملاء. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "lastTripDate": "آخر رحلة",
    "name": "الاسم",
    "nationalId": {
      "available": "متاح",
      "back": "الخلف",
      "front": "الأمام",
      "notAvailable": "غير متاح",
      "status": "الحالة",
      "title": "الرقم القومي",
      "unlock": "فتح",
      "vaultLocked": "القبو مقفل",
      "view": "عرض"
    },
    "new": "عميل جديد",
    "notes": "ملاحظات",
    "phone": "رقم الهاتف",
    "registered": "مسجل",
    "save": "حفظ العميل",
    "search": {
      "placeholder": "البحث بالاسم أو رقم الهاتف..."
    },
    "sort": {
      "createdAt_asc": "أقدم أول رحلة",
      "createdAt_desc": "أحدث أول رحلة",
      "lastTripDate_asc": "أقدم آخر رحلة",
      "lastTripDate_desc": "أحدث آخر رحلة",
      "name_asc": "الاسم (أ-ي)",
      "name_desc": "الاسم (ي-أ)",
      "phone_asc": "رقم الهاتف (أ-ي)",
      "phone_desc": "رقم الهاتف (ي-أ)",
      "totalBookings_asc": "أقل حجوزات",
      "totalBookings_desc": "أكثر حجوزات",
      "totalSpent_asc": "أقل إنفاق",
      "totalSpent_desc": "أكثر إنفاق"
    },
    "tags": "العلامات",
    "totalAmountDue": "إجمالي المبلغ المستحق",
    "totalBookings": "الحجوزات",
    "totalSpent": "الإنفاق",
    "view": "عرض العميل",
    "yourClients": "عملاؤك"
  },
  "close": "إغلاق",
  "comma": "، ",
  "confirm": "تأكيد",
  "continue": "متابعة",
  "copy": {
    "code": "نسخ الرمز",
    "copied": "تم النسخ!",
    "id": "نسخ المعرف",
    "link": "نسخ الرابط"
  },
  "date": {
    "date": "التاريخ",
    "end": "تاريخ الانتهاء",
    "select": "اختر تاريخاً",
    "start": "تاريخ البدء"
  },
  "day_few": "{{count}} أيام",
  "day_many": "{{count}} أيام",
  "day_one": "يوم واحد",
  "day_other": "{{count}} أيام",
  "day_two": "يومان",
  "day_zero": "0 أيام",
  "delete": "حذف",
  "discountCode": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع رموز الخصم.",
        "title": "لا توجد رموز خصم تطابق المرشحات"
      },
      "noFilters": {
        "description": "رمز الخصم الذي تبحث عنه غير موجود أو قد تم حذفه.",
        "title": "رمز الخصم غير موجود"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل رمز الخصم هذا. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض رمز الخصم هذا. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "رمز خصم جديد"
  },
  "discountCodes": {
    "FIXED": "ثابت",
    "PERCENTAGE": "نسبة مئوية",
    "allTrips": "جميع الرحلات",
    "allTripsSelected": "تم تحديد جميع الرحلات",
    "code": "الرمز",
    "codeExists": "الرمز موجود بالفعل",
    "create": {
      "error": {
        "description": "تعذر إنشاء رمز الخصم. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم إنشاء رمز الخصم بنجاح."
      }
    },
    "createdAt": "تاريخ الإنشاء",
    "delete": {
      "confirm": {
        "description": "هل أنت متأكد من حذف رمز الخصم هذا؟ لا يمكن التراجع عن هذا الإجراء.",
        "title": "حذف رمز الخصم"
      },
      "error": {
        "description": "تعذر حذف رمز الخصم. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم حذف رمز الخصم بنجاح."
      }
    },
    "discountCode": "رمز الخصم",
    "edit": {
      "edit": "تعديل رمز الخصم",
      "error": {
        "description": "تعذر تعديل رمز الخصم. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تعديل رمز الخصم بنجاح."
      }
    },
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع رموز الخصم.",
        "title": "لا توجد رموز خصم تطابق المرشحات"
      },
      "noFilters": {
        "description": "بمجرد استخدام رمز الخصم، سيظهر هنا.",
        "title": "لا توجد رموز خصم بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل رموز الخصم. يرجى المحاولة مرة أخرى."
    },
    "expiresAt": "تاريخ الانتهاء",
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على رموز خصم للتصدير.",
        "error": {
          "description": "تعذر تصدير رموز الخصم إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع رموز الخصم إلى PDF بنجاح."
        }
      },
      "button": "تصدير إلى PDF",
      "error": {
        "description": "تعذر تصدير رمز الخصم إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير رمز الخصم إلى PDF بنجاح."
      }
    },
    "filters": {
      "expiresAt": "تاريخ الانتهاء",
      "newOnly": "عملاء جدد فقط",
      "no": "لا",
      "notNewOnly": "ليس للعملاء الجدد فقط",
      "type": "النوع",
      "usageLimit": "الحد الأقصى للاستخدام",
      "value": "القيمة",
      "yes": "نعم"
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض رموز الخصم. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "رمز خصم جديد",
    "newOnly": "عملاء جدد فقط",
    "numberOfTrips": "الرحلات المطبقة",
    "numberOfUses": "مرات الاستخدام",
    "save": "حفظ رمز الخصم",
    "search": {
      "placeholder": "البحث بالرمز..."
    },
    "sort": {
      "code_asc": "الرمز (أ-ي)",
      "code_desc": "الرمز (ي-أ)",
      "createdAt_asc": "الأقدم",
      "createdAt_desc": "الأحدث",
      "expiresAt_asc": "أحدث تاريخ انتهاء",
      "expiresAt_desc": "أقدم تاريخ انتهاء",
      "newOnly_asc": "عملاء جدد فقط",
      "newOnly_desc": "عملاء جدد فقط",
      "type_asc": "أقل قيمة",
      "type_desc": "أعلى قيمة",
      "usageLimit_asc": "أقل حد أقصى للاستخدام",
      "usageLimit_desc": "أعلى حد أقصى للاستخدام"
    },
    "type": "النوع",
    "usageLimit": "الحد الأقصى للاستخدام",
    "value": "القيمة",
    "yourDiscountCodes": "رموز الخصم الخاصة بك"
  },
  "edit": "تعديل",
  "egp": "جنيه",
  "employee": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الموظفين.",
        "title": "لا يوجد موظف يطابق المرشحات"
      },
      "noFilters": {
        "description": "الموظف الذي تبحث عنه غير موجود أو قد تم حذفه.",
        "title": "الموظف غير موجود"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذا الموظف. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذا الموظف. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "موظف جديد"
  },
  "employees": {
    "active": "نشط",
    "create": {
      "error": {
        "description": "تعذر إنشاء الموظف. يرجى المحاولة مرة أخرى.",
        "roleId": "الدور غير موجود"
      },
      "success": {
        "description": "تم إنشاء الموظف بنجاح."
      }
    },
    "dateJoined": "تاريخ الانضمام",
    "delete": {
      "confirm": {
        "description": "هل أنت متأكد من حذف هذا الموظف؟ لا يمكن التراجع عن هذا الإجراء.",
        "title": "حذف الموظف"
      },
      "error": {
        "description": "تعذر حذف الموظف. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم حذف الموظف بنجاح."
      }
    },
    "detail": {
      "employeeInfo": "معلومات الموظف"
    },
    "edit": {
      "edit": "تعديل الموظف",
      "error": {
        "description": "تعذر تعديل الموظف. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تعديل الموظف بنجاح."
      }
    },
    "employees": "الموظفون",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الموظفين.",
        "title": "لا يوجد موظفون يطابقون المرشحات"
      },
      "noFilters": {
        "description": "أضف أول موظف لبدء بناء فريقك.",
        "title": "لا يوجد موظفون بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل الموظفين. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على موظفين للتصدير.",
        "error": {
          "description": "تعذر تصدير الموظفين إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع الموظفين إلى PDF بنجاح."
        }
      },
      "button": "تصدير إلى PDF",
      "error": {
        "description": "تعذر تصدير الموظف إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير الموظف إلى PDF بنجاح."
      }
    },
    "filters": {
      "dateJoined": "تاريخ الانضمام",
      "isActive": "الحالة",
      "role": "الدور",
      "roles": "الأدوار"
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض الموظفين. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "inactive": "غير نشط",
    "name": "الاسم",
    "new": "موظف جديد",
    "password": "كلمة المرور",
    "phone": "رقم الهاتف",
    "role": "الدور",
    "save": "حفظ الموظف",
    "search": {
      "placeholder": "البحث بالاسم أو رقم الهاتف..."
    },
    "showPassword": {
      "error": {
        "description": "تعذر عرض كلمة المرور. يرجى المحاولة مرة أخرى."
      }
    },
    "sort": {
      "createdAt_asc": "الأقدم",
      "createdAt_desc": "الأحدث",
      "isActive_asc": "غير النشط أولاً",
      "isActive_desc": "النشط أولاً",
      "name_asc": "الاسم (أ-ي)",
      "name_desc": "الاسم (ي-أ)",
      "phone_asc": "رقم الهاتف (أ-ي)",
      "phone_desc": "رقم الهاتف (ي-أ)",
      "role_asc": "الدور (أ-ي)",
      "role_desc": "الدور (ي-أ)"
    },
    "status": "الحالة",
    "updatePassword": {
      "error": {
        "description": "تعذر تحديث كلمة المرور. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تحديث كلمة المرور بنجاح."
      },
      "updatePassword": "تحديث كلمة المرور"
    },
    "username": "اسم المستخدم",
    "view": "عرض الموظف",
    "yourEmployees": "موظفوك"
  },
  "empty": {
    "filters": {
      "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الموارد.",
      "title": "لا يوجد مورد يطابق المرشحات"
    },
    "new": "مورد جديد",
    "noFilters": {
      "description": "المورد الذي تبحث عنه غير موجود أو قد تم حذفه.",
      "title": "المورد غير موجود"
    }
  },
  "error": {
    "description": "واجهنا خطأ أثناء تحميل هذا المورد. يرجى المحاولة مرة أخرى.",
    "title": "خطأ في تحميل المورد"
  },
  "export": "تصدير",
  "exportPDF": "تصدير إلى PDF",
  "exporting": "جارٍ التصدير...",
  "filters": {
    "all": "الكل",
    "apply": "تطبيق المرشحات",
    "clear": "مسح المرشحات",
    "filter": "مرشح",
    "filters": "المرشحات",
    "search": "بحث",
    "status": "الحالة"
  },
  "finance": {
    "breakdowns": {
      "comingSoon": "قريباً",
      "noData": "لا توجد بيانات متاحة",
      "paymentStatus": "حالة الدفع",
      "refundReasons": "أسباب الاسترداد",
      "revenueByPaymentMethod": "الإيرادات حسب طريقة الدفع",
      "revenueByTrip": "الإيرادات حسب الرحلة",
      "title": "التفصيل"
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل البيانات المالية. يرجى المحاولة مرة أخرى."
    },
    "export": "تصدير",
    "exportPDF": {
      "error": {
        "description": "تعذر تصدير التقرير المالي. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير التقرير المالي بنجاح."
      }
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض البيانات المالية. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "kpis": {
      "allTime": "كل الأوقات",
      "amountDue": "المبلغ المستحق",
      "amountDueTooltip": "إجمالي الرصيد المعلق عبر جميع الحجوزات التي لا يزال العملاء بحاجة لدفعها.",
      "availableBalance": "متاح للسحب",
      "held": "محتجز",
      "heldTooltip": "أموال مكتسبة من العملاء ولكن محتجزة مؤقتاً لاحتمال الإلغاءات. بمجرد انتهاء موعد الإلغاء، يصبح هذا المبلغ متاحاً للإيداع.",
      "totalEarned": "إجمالي المكتسب",
      "totalRefunded": "إجمالي المسترد",
      "totalRevenue": "إجمالي الإيرادات"
    },
    "ledger": {
      "amount": "المبلغ",
      "client": "العميل",
      "date": "التاريخ",
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع المعاملات.",
          "title": "لا توجد معاملات تطابق المرشحات"
        },
        "noFilters": {
          "description": "لم يتم العثور على معاملات دفع للفترة المحددة.",
          "title": "لا توجد معاملات بعد"
        }
      },
      "error": {
        "description": "واجهنا خطأ أثناء تحميل المعاملات. يرجى المحاولة مرة أخرى."
      },
      "forbidden": {
        "description": "غير مسموح لك بعرض المعاملات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
      },
      "method": "الطريقة",
      "new": "معاملة جديدة",
      "reservation": "الحجز",
      "search": {
        "placeholder": "بحث في المعاملات..."
      },
      "status": "الحالة",
      "statuses": {
        "CAPTURED": "مكتمل",
        "FAILED": "فشل",
        "PENDING": "قيد الانتظار",
        "REFUNDED": "مسترد",
        "VOIDED": "ملغي"
      },
      "title": "معاملات الدفع",
      "trip": "الرحلة",
      "type": "النوع",
      "types": {
        "AUTH": "تفويض",
        "CAPTURE": "استيلاء",
        "PAYMENT": "دفعة",
        "REFUND": "استرداد",
        "VOID": "إلغاء"
      }
    },
    "title": "المالية",
    "trends": {
      "amount": "المبلغ",
      "paymentsOverTime": "المدفوعات مع مرور الوقت",
      "refundsOverTime": "المستردات مع مرور الوقت",
      "title": "الاتجاهات"
    },
    "withdraw": {
      "amount": "المبلغ",
      "amountExceedsBalance": "المبلغ يتجاوز الرصيد المتاح",
      "availableBalance": "المتاح للسحب",
      "bankCardNumber": "رقم البطاقة البنكية",
      "bankCode": "البنك",
      "bankTransactionType": "نوع المعاملة",
      "button": "سحب",
      "error": {
        "description": "تعذر معالجة السحب. يرجى المحاولة مرة أخرى."
      },
      "fullName": "الاسم الكامل",
      "issuers": {
        "BANK_CARD": "بطاقة بنكية",
        "BANK_WALLET": "محفظة",
        "ETISALAT": "اتصالات",
        "INSTANT_BANK": "فوري",
        "MOBILE_WALLET": "محفظة إلكترونية",
        "POST": "البريد المصري",
        "ORANGE": "أورانج",
        "VODAFONE": "فودافون"
      },
      "method": "طريقة السحب",
      "nationalId": "الرقم القومي",
      "phone": "رقم الهاتف",
      "saveMethod": "حفظ هذه الطريقة للسحب المستقبلي",
      "submit": "سحب",
      "success": {
        "description": "تم إرسال طلب السحب بنجاح.",
        "title": "تم بدء السحب"
      },
      "title": "سحب الأموال",
      "transactionTypes": {
        "CASH_TRANSFER": "تحويل نقدي",
        "CREDIT_CARD": "بطاقة ائتمان",
        "PREPAID_CARD": "بطاقة مسبقة الدفع",
        "SALARY": "راتب"
      }
    },
    "withdrawals": {
      "amount": "المبلغ",
      "date": "التاريخ",
      "description": "الوصف",
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع عمليات السحب.",
          "title": "لا توجد عمليات سحب تطابق المرشحات"
        },
        "noFilters": {
          "description": "سجل عمليات السحب الخاص بك سيظهر هنا بمجرد إجراء عملية سحب.",
          "title": "لا توجد عمليات سحب بعد"
        }
      },
      "error": {
        "description": "واجهنا خطأ أثناء تحميل عمليات السحب. يرجى المحاولة مرة أخرى."
      },
      "forbidden": {
        "description": "غير مسموح لك بعرض عمليات السحب. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
      },
      "method": "الطريقة",
      "nationalId": "الرقم القومي",
      "number": "الرقم",
      "status": "الحالة",
      "statuses": {
        "COMPLETED": "مكتمل",
        "FAILED": "فشل",
        "PENDING": "قيد الانتظار"
      },
      "title": "سجل السحوبات"
    }
  },
  "forbidden": {
    "description": {
      "action": "غير مسموح لك بتنفيذ هذا الإجراء. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ.",
      "resource": "غير مسموح لك بالوصول إلى هذا المورد. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "title": "تم رفض الوصول"
  },
  "home": {
    "reservations": {
      "title": "حجوزات جديدة"
    },
    "title": "مرحباً، {{name}}",
    "trips": {
      "upcoming": {
        "title": "الرحلات القادمة"
      }
    }
  },
  "loadMore": "تحميل المزيد",
  "login": {
    "continueWithGoogle": "المتابعة مع Google",
    "description": "سجل الدخول لإدارة وكالتك",
    "login": "تسجيل الدخول",
    "noAccount": "ليس لديك حساب؟",
    "password": "كلمة المرور",
    "register": "التسجيل",
    "rememberMe": "تذكرني",
    "title": "مرحباً بعودتك",
    "username": "اسم المستخدم"
  },
  "logout": "تسجيل الخروج",
  "maximum": "الحد الأقصى",
  "menu": "القائمة",
  "minimum": "الحد الأدنى",
  "no": "لا",
  "noOptions": "لا توجد خيارات",
  "noResults": "لم يتم العثور على نتائج",
  "nom": "رقم",
  "none": "لا شيء",
  "notFound": {
    "description": "المورد الذي تبحث عنه غير موجود أو قد تم حذفه.",
    "title": "غير موجود"
  },
  "onboarding": {
    "vaultPassword": {
      "confirmPassword": "تأكيد كلمة مرور القبو",
      "description": "كلمة مرور القبو على مستوى الوكالة تُستخدم لتشفير وحماية المعلومات الحساسة مثل بيانات الرقم القومي. يرجى اختيار كلمة مرور قوية والحفاظ عليها آمنة.",
      "descriptionHighlighted": "لن تُستخدم كلمة المرور هذه لتسجيل الدخول، يمكنك تغييرها لاحقاً في الإعدادات.",
      "password": "كلمة مرور القبو",
      "title": "تعيين كلمة مرور القبو"
    }
  },
  "options": "الخيارات",
  "overview": "نظرة عامة",
  "payments": {
    "edit": "تعديل الدفعة",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع المدفوعات.",
        "title": "لا توجد مدفوعات تطابق المرشحات"
      },
      "noFilters": {
        "description": "المدفوعات من هذا الحجز ستظهر هنا بمجرد إنشائها.",
        "title": "لا توجد مدفوعات بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل المدفوعات. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض المدفوعات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "دفعة جديدة",
    "update": {
      "error": {
        "description": "تعذر تحديث الدفعة. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تحديث الدفعة بنجاح."
      }
    },
    "void": "إلغاء الدفعة",
    "voidPayment": {
      "error": {
        "description": "تعذر إلغاء الدفعة. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم إلغاء الدفعة بنجاح."
      }
    }
  },
  "pdf": {
    "auditLog": {
      "dateRange": "النطاق الزمني:",
      "entries": "الإدخالات",
      "noEntriesFound": "لم يتم العثور على إدخالات سجل التدقيق",
      "summary": "الملخص",
      "title": "سجل التدقيق",
      "totalEntries": "إجمالي الإدخالات:"
    },
    "clients": {
      "amountDue": "المبلغ المستحق:",
      "clientInformation": "معلومات العميل",
      "clientNationalId": "الرقم القومي للعميل",
      "email": "البريد الإلكتروني:",
      "firstTripDate": "تاريخ أول رحلة:",
      "lastTripDate": "تاريخ آخر رحلة:",
      "notes": "الملاحظات:",
      "phoneNumber": "رقم الهاتف:",
      "statistics": "الإحصائيات",
      "tags": "العلامات:",
      "title": "سجل العميل",
      "totalBookings": "إجمالي الحجوزات:",
      "totalSpent": "إجمالي الإنفاق:"
    },
    "common": {
      "action": "الإجراء",
      "adults": "بالغون",
      "amount": "المبلغ",
      "children": "أطفال",
      "client": "العميل",
      "date": "التاريخ",
      "id": "المعرف",
      "method": "الطريقة",
      "model": "النموذج",
      "name": "الاسم:",
      "no": "لا",
      "number": "#",
      "permission": "صلاحية",
      "permissions": "صلاحيات",
      "qty": "الكمية",
      "refund": "(استرداد)",
      "reservation": "الحجز",
      "resource": "المورد",
      "serialNumber": "الرقم التسلسلي:",
      "status": "الحالة:",
      "total": "الإجمالي",
      "trip": "الرحلة",
      "unitPrice": "سعر الوحدة",
      "user": "المستخدم",
      "yes": "نعم"
    },
    "discountCodes": {
      "code": "الرمز:",
      "createdAt": "تاريخ الإنشاء:",
      "expiresAt": "تاريخ الانتهاء:",
      "information": "المعلومات",
      "newOnly": "للعملاء الجدد فقط:",
      "statistics": "الإحصائيات",
      "title": "سجل رمز الخصم",
      "totalReservations": "إجمالي الحجوزات:",
      "totalRevenue": "إجمالي الإيرادات:",
      "type": "النوع:",
      "usageLimit": "حد الاستخدام:",
      "value": "القيمة:"
    },
    "employees": {
      "dateJoined": "تاريخ الانضمام:",
      "employeeInformation": "معلومات الموظف",
      "permissions": "الصلاحيات:",
      "permissionsSection": "الصلاحيات",
      "phoneNumber": "رقم الهاتف:",
      "roleInformation": "معلومات الدور",
      "roleName": "اسم الدور:",
      "title": "سجل الموظف",
      "username": "اسم المستخدم:"
    },
    "finances": {
      "amountDue": "المبلغ المستحق:",
      "financialOverview": "نظرة عامة مالية",
      "heldAmount": "المبلغ المحتجز:",
      "netAmount": "صافي المبلغ:",
      "noPaymentsFound": "لم يتم العثور على مدفوعات",
      "paymentLedger": "سجل المدفوعات",
      "reservation": "الحجز",
      "title": "التقرير المالي",
      "totalPayments": "إجمالي المدفوعات:",
      "totalRefunded": "إجمالي المسترد:",
      "totalRefunds": "إجمالي الاستردادات:",
      "totalRevenue": "إجمالي الإيرادات:"
    },
    "reservations": {
      "adult": "بالغ",
      "amountDue": "المبلغ المستحق:",
      "amountRefunded": "المبلغ المسترد:",
      "cancelledAt": "تم الإلغاء في:",
      "child": "طفل",
      "clientInformation": "معلومات العميل",
      "clientNationalId": "الرقم القومي للعميل",
      "createdAt": "تم الإنشاء في:",
      "createdById": "تم الإنشاء بواسطة (المعرف):",
      "currentStatus": "الحالة الحالية:",
      "financialBreakdown": "التفصيل المالي",
      "item": "العنصر",
      "payments": "المدفوعات",
      "refundDue": "المسترد المستحق:",
      "reservationInformation": "معلومات الحجز",
      "reservationPolicy": "سياسة الحجز",
      "title": "سجل الحجز الداخلي",
      "totalPaid": "إجمالي المدفوع:",
      "totalPrice": "السعر الإجمالي:",
      "totalRefundable": "إجمالي القابل للاسترداد:",
      "tripInformation": "معلومات الرحلة"
    },
    "roles": {
      "createdAt": "تم الإنشاء في:",
      "numberOfEmployees": "عدد الموظفين:",
      "numberOfPermissions": "عدد الصلاحيات:",
      "permissions": "الصلاحيات",
      "roleInformation": "معلومات الدور",
      "roleName": "اسم الدور:",
      "title": "سجل الدور",
      "updatedAt": "تم التحديث في:"
    },
    "trips": {
      "accessibility": "إمكانية الوصول:",
      "adultCancellationFee": "رسوم إلغاء البالغ:",
      "adultPrice": "سعر البالغ:",
      "adultPriceColumn": "سعر البالغ",
      "adultReservationFee": "رسوم حجز البالغ:",
      "amountDue": "المبلغ المستحق:",
      "audience": "الجمهور:",
      "cancellationAllowed": "الإلغاء مسموح:",
      "cancellationDeadline": "موعد الإلغاء:",
      "cancellationPolicy": "سياسة الإلغاء",
      "childCancellationFee": "رسوم إلغاء الطفل:",
      "childMaximumAge": "الحد الأقصى لعمر الطفل:",
      "childPrice": "سعر الطفل:",
      "childPriceColumn": "سعر الطفل",
      "childReservationFee": "رسوم حجز الطفل:",
      "currentReservations": "الحجوزات الحالية:",
      "currentRevenue": "الإيرادات الحالية:",
      "food": "الطعام:",
      "groupPricing": "تسعير المجموعة",
      "guides": "المرشدون:",
      "hotelInformation": "معلومات الفندق",
      "hotelLocation": "موقع الفندق:",
      "hotelName": "اسم الفندق:",
      "locations": "المواقع:",
      "maxCapacity": "السعة القصوى:",
      "minimumPeople": "الحد الأدنى للأشخاص",
      "noReservationsFound": "لم يتم العثور على حجوزات",
      "performance": "الأداء",
      "pricing": "التسعير",
      "reservationDeadline": "موعد الحجز:",
      "reservations": "الحجوزات",
      "serial": "تسلسلي",
      "tags": "العلامات",
      "targetRevenue": "الإيرادات المستهدفة:",
      "timeline": "الجدول الزمني:",
      "title": "سجل الرحلة",
      "totalPrice": "السعر الإجمالي",
      "transportation": "وسائل النقل:",
      "tripImages": "صور الرحلة",
      "tripInformation": "معلومات الرحلة",
      "viewOnGoogleMaps": "عرض على خرائط Google",
      "visible": "مرئي:"
    }
  },
  "per_person_few": "لكل {{count}} أشخاص",
  "per_person_many": "لكل {{count}} أشخاص",
  "per_person_one": "لكل شخص",
  "per_person_other": "لكل {{count}} أشخاص",
  "per_person_two": "لكل شخصين",
  "per_person_zero": "لأحد",
  "permissions": {
    "category": "الفئة",
    "create": "إنشاء",
    "delete": "حذف",
    "get": "عرض",
    "modify": "تعديل",
    "none": "لا توجد صلاحيات",
    "permissions": "الصلاحيات",
    "resources": {
      "analytics": "تحليلات",
      "client": "عميل",
      "discountCode": "كود الخصم",
      "employee": "موظف",
      "finance": "مالية",
      "nationalId": "الهوية الوطنية",
      "reservation": "حجز",
      "trip": "رحلة"
    },
    "update": "تعديل",
    "view": "عرض"
  },
  "person_few": "{{count}} أشخاص",
  "person_many": "{{count}} أشخاص",
  "person_one": "شخص واحد",
  "person_other": "{{count}} أشخاص",
  "person_two": "شخصان",
  "person_zero": "0 أشخاص",
  "present": "حاضر",
  "remove": "إزالة",
  "reservation": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الحجوزات.",
        "new": "حجز جديد",
        "title": "لا يوجد حجز يطابق المرشحات"
      },
      "noFilters": {
        "description": "الحجز الذي تبحث عنه غير موجود أو قد تم حذفه.",
        "title": "الحجز غير موجود"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذا الحجز. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذا الحجز. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "حجز جديد"
  },
  "reservations": {
    "adults": "بالغون",
    "all": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الحجوزات.",
          "title": "لا توجد حجوزات تطابق المرشحات"
        },
        "noFilters": {
          "description": "ستظهر هنا الحجوزات خلال آخر 30 يوماً.",
          "title": "لا توجد حجوزات بعد"
        }
      },
      "new": "حجز جديد"
    },
    "amountDue": "مستحق",
    "amountPaid": "مدفوع",
    "amountRefunded": "مسترد",
    "cancelled": "ملغى",
    "changeClient": "تغيير",
    "childReservationFee": "رسوم حجز الطفل",
    "children": "أطفال",
    "client": {
      "client": "العميل",
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الحجوزات.",
          "title": "لا توجد حجوزات تطابق المرشحات"
        },
        "noFilters": {
          "description": "الحجوزات من هذا العميل ستظهر هنا بمجرد حجزه لرحلة.",
          "title": "لا توجد حجوزات بعد"
        }
      },
      "new": "حجز جديد"
    },
    "clientExists": {
      "createNew": "إنشاء عميل جديد",
      "description": "هذا العميل موجود بالفعل بهذا الرقم. هل لا تزال تريد إنشاء عميل جديد؟",
      "title": "العميل موجود بالفعل"
    },
    "contact": "جهة الاتصال",
    "create": {
      "error": {
        "description": "تعذر إنشاء الحجز. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم إنشاء الحجز بنجاح."
      }
    },
    "createdAt": "تم الإنشاء",
    "dateCreated": "تاريخ الإنشاء",
    "discountCode": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الحجوزات.",
          "title": "لا توجد حجوزات تطابق المرشحات"
        },
        "noFilters": {
          "description": "ستظهر هنا الحجوزات التي تستخدم رمز الخصم هذا.",
          "title": "لا توجد حجوزات بعد"
        }
      },
      "new": "حجز جديد"
    },
    "edit": {
      "cancel": {
        "confirm": {
          "button": "إلغاء الحجز",
          "description": "هل أنت متأكد من إلغاء هذا الحجز؟ لا يمكن التراجع عن هذا الإجراء.",
          "title": "إلغاء الحجز"
        },
        "success": {
          "description": "تم إلغاء الحجز بنجاح."
        }
      },
      "error": {
        "description": "تعذر تعديل الحجز. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تعديل الحجز بنجاح."
      }
    },
    "editReservation": "تعديل الحجز",
    "error": {
      "description": "واجهنا خطأ أثناء تحميل حجوزاتك. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على حجوزات للتصدير.",
        "error": {
          "description": "تعذر تصدير الحجوزات إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع الحجوزات إلى PDF بنجاح."
        }
      },
      "error": {
        "description": "تعذر تصدير الحجز إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير الحجز إلى PDF بنجاح."
      },
      "title": "تصدير إلى PDF",
      "vaultLocked": {
        "description": "القبو مقفل. هل تريد فتحه لتضمين الرقم القومي في PDF، أم تصدير بدون الرقم القومي؟",
        "exportWithoutId": "تصدير بدون الرقم القومي",
        "stillLocked": "القبو لا يزال مقفلاً. يرجى فتحه أولاً.",
        "title": "القبو مقفل",
        "unlock": "فتح القبو"
      }
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض الحجوزات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "force": {
      "description": {
        "added_few": "لكنك تحاول تأكيد {{count}} مقعد. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "added_many": "لكنك تحاول تأكيد {{count}} مقعد. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "added_one": "لكنك تحاول تأكيد مقعد واحد. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "added_other": "لكنك تحاول تأكيد {{count}} مقعد. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "added_two": "لكنك تحاول تأكيد مقعدين. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "added_zero": "لكنك تحاول تأكيد 0 مقعد. المتابعة قد تؤدي إلى تجاوز سعة الرحلة.",
        "confirm": "هل تريد التأكيد على أي حال؟",
        "left_few": "هذه الرحلة لديها {{count}} مقعد متبقي فقط،",
        "left_many": "هذه الرحلة لديها {{count}} مقعد متبقي فقط،",
        "left_one": "هذه الرحلة لديها مقعد واحد متبقي فقط،",
        "left_other": "هذه الرحلة لديها {{count}} مقعد متبقي فقط،",
        "left_two": "هذه الرحلة لديها مقعدان متبقيان فقط،",
        "left_zero": "هذه الرحلة لا يوجد لديها مقاعد متبقية،"
      },
      "title": "لا توجد مقاعد كافية متاحة"
    },
    "newReservation": "حجز جديد",
    "payments": {
      "success": {
        "description": "تم إضافة الدفعة بنجاح."
      },
      "title": "المدفوعات"
    },
    "priceUpdated": {
      "description": "تم تغيير سعر الرحلة. يرجى المراجعة وإرسال الحجز مرة أخرى.",
      "title": "تم تحديث سعر الرحلة"
    },
    "refund": "استرداد",
    "refundDue": "المسترد المستحق",
    "reservation": "الحجز",
    "reservationDeadline": "موعد الحجز",
    "reservationFee": "رسوم الحجز",
    "reservationNumber": "رقم الحجز",
    "reservations": "الحجوزات",
    "save": "حفظ الحجز",
    "selectClient": "اختر العميل",
    "status": {
      "NO_REFUND": "ملغى بدون استرداد",
      "OVERPAID": "مدفوع زائد",
      "OVERREFUNDED": "مسترد زائد",
      "PAYMENT": "دفعة",
      "PAYMENT_COMPLETE": "مدفوع بالكامل",
      "PAYMENT_PARTIAL": "مدفوع جزئياً",
      "PAYMENT_PENDING": "في انتظار الدفع",
      "PAYMENT_RESERVATION": "تم تأمين الحجز",
      "REFUND": "استرداد",
      "REFUND_COMPLETE": "مسترد",
      "REFUND_PARTIAL": "مسترد جزئياً",
      "REFUND_PENDING": "في انتظار الاسترداد",
      "status": "الحالة"
    },
    "summary": "الملخص",
    "totalPrice": "السعر الإجمالي",
    "totalRefund": "إجمالي الاسترداد",
    "trip": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الحجوزات.",
          "title": "لا توجد حجوزات تطابق المرشحات"
        },
        "noFilters": {
          "description": "الحجوزات من العملاء ستظهر هنا بمجرد حجزهم لهذه الرحلة.",
          "title": "لا توجد حجوزات بعد"
        }
      },
      "new": "حجز جديد"
    },
    "updateAmountPaid": "تحديث المدفوع",
    "updateAmountRefunded": "تحديث المسترد"
  },
  "return": "عودة",
  "returnHome": "العودة للصفحة الرئيسية",
  "revenueProgress": "تقدم الإيرادات",
  "role": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الأدوار.",
        "title": "لا يوجد دور يطابق المرشحات"
      },
      "noFilters": {
        "description": "الدور الذي تبحث عنه غير موجود أو قد تم حذفه.",
        "title": "الدور غير موجود"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذا الدور. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذا الدور. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "دور جديد"
  },
  "roles": {
    "create": {
      "error": {
        "description": "تعذر إنشاء الدور. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم إنشاء الدور بنجاح."
      }
    },
    "delete": {
      "confirm": {
        "description": "هل أنت متأكد من حذف هذا الدور؟ لا يمكن التراجع عن هذا الإجراء.",
        "title": "حذف الدور"
      },
      "error": {
        "description": "تعذر حذف الدور. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم حذف الدور بنجاح."
      }
    },
    "edit": {
      "edit": "تعديل الدور",
      "error": {
        "description": "تعذر تعديل الدور. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تعديل الدور بنجاح."
      }
    },
    "employees_few": "{{count}} موظف",
    "employees_many": "{{count}} موظف",
    "employees_one": "موظف واحد",
    "employees_other": "{{count}} موظف",
    "employees_two": "موظفان",
    "employees_zero": "لا يوجد موظفون",
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الأدوار.",
        "title": "لا توجد أدوار تطابق المرشحات"
      },
      "noFilters": {
        "description": "ابدأ بإنشاء دورك الأول. لن يستغرق الأمر سوى بضع دقائق!",
        "title": "لا توجد أدوار بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل الأدوار. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على أدوار للتصدير.",
        "error": {
          "description": "تعذر تصدير الأدوار إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع الأدوار إلى PDF بنجاح."
        }
      },
      "button": "تصدير إلى PDF",
      "error": {
        "description": "تعذر تصدير الدور إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير الدور إلى PDF بنجاح."
      }
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض الأدوار. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "name": "اسم الدور",
    "new": "دور جديد",
    "permissions_few": "{{count}} صلاحية",
    "permissions_many": "{{count}} صلاحية",
    "permissions_one": "صلاحية واحدة",
    "permissions_other": "{{count}} صلاحية",
    "permissions_two": "صلاحيتان",
    "permissions_zero": "لا توجد صلاحيات",
    "roles": "الأدوار",
    "save": "حفظ الدور",
    "sort": {
      "name_asc": "الاسم (أ-ي)",
      "name_desc": "الاسم (ي-أ)",
      "numberOfEmployees_asc": "أقل موظفين",
      "numberOfEmployees_desc": "أكثر موظفين",
      "numberOfPermissions_asc": "أقل صلاحيات",
      "numberOfPermissions_desc": "أكثر صلاحيات"
    },
    "viewEmployees": "عرض الموظفين",
    "yourRoles": "أدوارك"
  },
  "save": "حفظ",
  "search": "بحث",
  "settings": {
    "agency": {
      "loadError": "تعذر تحميل معلومات الوكالة. يرجى المحاولة مرة أخرى.",
      "update": {
        "error": {
          "description": "تعذر تحديث معلومات الوكالة. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تحديث معلومات الوكالة بنجاح."
        }
      }
    },
    "general": {
      "darkMode": "التبديل إلى الوضع الداكن",
      "language": "اللغة",
      "languageDescription": "اختر لغتك المفضلة للواجهة.",
      "lightMode": "التبديل إلى الوضع الفاتح",
      "theme": {
        "dark": "الوضع الداكن",
        "light": "الوضع الفاتح",
        "title": "المظهر"
      },
      "themeDescription": "التبديل بين الوضع الفاتح والداكن."
    },
    "nationalId": {
      "confirmPassword": "تأكيد كلمة المرور",
      "deletePassword": {
        "confirm": {
          "description": "هل أنت متأكد من حذف كلمة مرور الرقم القومي؟ لا يمكن التراجع عن هذا الإجراء.",
          "title": "حذف كلمة المرور"
        },
        "error": {
          "description": "تعذر حذف كلمة المرور. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم حذف كلمة المرور بنجاح."
        },
        "title": "حذف كلمة المرور"
      },
      "description": "عرض معلومات حول حالة قبو الرقم القومي الخاص بك.",
      "lastUpdated": "آخر تحديث",
      "lock": {
        "error": {
          "description": "تعذر قفل القبو. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم قفل القبو بنجاح"
        },
        "title": "قفل القبو"
      },
      "password": "كلمة المرور",
      "passwordNotSet": "كلمة المرور غير معينة",
      "passwordSet": "كلمة المرور معينة",
      "passwordSetOn": "تم تعيين كلمة المرور في",
      "passwordStatus": "حالة كلمة المرور",
      "setPassword": {
        "error": {
          "description": "تعذر تعيين كلمة المرور. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تعيين كلمة المرور بنجاح"
        },
        "title": "تعيين كلمة المرور"
      },
      "setPasswordDescription": "قم بتعيين كلمة مرور لعرض الأرقام القومية",
      "title": "قبو الرقم القومي",
      "unlock": {
        "description": "أدخل كلمة مرورك لفتح القبو.",
        "error": {
          "description": "كلمة المرور التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى.",
          "incorrectPassword": "كلمة مرور غير صحيحة"
        },
        "success": {
          "description": "تم فتح القبو بنجاح"
        },
        "title": "فتح القبو"
      },
      "vaultLocked": "القبو مقفل",
      "vaultStatus": "حالة القبو",
      "vaultUnlocked": "القبو مفتوح"
    },
    "tabs": {
      "agency": "معلومات الوكالة",
      "general": "عام",
      "nationalId": "الرقم القومي"
    },
    "title": "الإعدادات"
  },
  "sidebar": {
    "nav": {
      "analytics": "التحليلات",
      "auditLog": "سجل التدقيق",
      "clients": "العملاء",
      "discountCodes": "رموز الحصم",
      "employees": "الموظفون",
      "finances": "المالية",
      "home": "الرئيسية",
      "roles": "الأدوار",
      "settings": "الإعدادات",
      "trips": "الرحلات"
    }
  },
  "sort": {
    "amount_asc": "الأقل مبلغاً",
    "amount_desc": "الأعلى مبلغاً",
    "date_asc": "الأقدم أولاً",
    "date_desc": "الأحدث أولاً",
    "sortBy": "ترتيب حسب"
  },
  "success": "نجح",
  "tag_few": "{{count}} علامة",
  "tag_many": "{{count}} علامة",
  "tag_one": "علامة واحدة",
  "tag_other": "{{count}} علامة",
  "tag_two": "علامتان",
  "tag_zero": "0 علامة",
  "tags": {
    "placeholder": "اكتب اسم العلامة واضغط Enter"
  },
  "tier_few": "{{count}} مستوى",
  "tier_many": "{{count}} مستوى",
  "tier_one": "مستوى واحد",
  "tier_other": "{{count}} مستوى",
  "tier_two": "مستويان",
  "tier_zero": "0 مستوى",
  "trip": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الرحلات المتاحة.",
        "title": "لا توجد رحلة تطابق المرشحات"
      },
      "noFilters": {
        "description": "الرحلة التي تبحث عنها غير موجودة أو قد تم حذفها.",
        "title": "الرحلة غير موجودة"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل هذه الرحلة. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض هذه الرحلة. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "رحلة جديدة",
    "trip": "رحلة"
  },
  "trip_selected_few": "تم تحديد {{count}} رحلات",
  "trip_selected_many": "تم تحديد {{count}} رحلة",
  "trip_selected_one": "تم تحديد رحلة واحدة",
  "trip_selected_other": "تم تحديد {{count}} رحلة",
  "trip_selected_two": "تم تحديد رحلتين",
  "trip_selected_zero": "لم يتم تحديد أي رحلات",
  "trips": {
    "booked": "محجوز",
    "cancellationPolicy": {
      "allowed": "الإلغاء مسموح",
      "cancellationDeadline": "موعد الإلغاء",
      "cancellationFee": "رسوم الإلغاء",
      "cancellationPolicy": "سياسة الإلغاء",
      "childCancellationFee": "رسوم إلغاء الطفل",
      "leaveEmptyForNoDeadline": "اتركه فارغاً إذا لم يكن هناك موعد",
      "leaveEmptyForNoFee": "اتركه فارغاً إذا لم تكن هناك رسوم"
    },
    "capacity": {
      "capacity": "السعة",
      "max": "السعة القصوى"
    },
    "client": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الرحلات.",
          "title": "لا توجد رحلات تطابق المرشحات"
        },
        "noFilters": {
          "description": "الرحلات المحجوزة من قبل هذا العميل ستظهر هنا.",
          "title": "لا توجد رحلات بعد"
        }
      },
      "new": "عميل جديد"
    },
    "create": {
      "error": {
        "description": "تعذر إنشاء الرحلة. يرجى المحاولة مرة أخرى.",
        "imageUpload": "فشل رفع الشعار"
      },
      "forbidden": {
        "description": "غير مسموح لك بإنشاء رحلات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
      },
      "success": {
        "description": "تم إنشاء الرحلة بنجاح."
      }
    },
    "currentAmountDue": "المبلغ المستحق",
    "delete": {
      "delete": "حذف الرحلة"
    },
    "description": "الوصف",
    "discountCode": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الرحلات.",
          "title": "لا توجد رحلات تطابق المرشحات"
        },
        "noFilters": {
          "description": "ستظهر هنا الرحلات التي يعمل معها رمز الخصم هذا.",
          "title": "لا توجد رحلات بعد"
        }
      },
      "new": "رمز خصم جديد"
    },
    "duration": "المدة",
    "edit": {
      "edit": "تعديل الرحلة",
      "error": {
        "description": "تعذر تعديل الرحلة. يرجى المحاولة مرة أخرى."
      },
      "forbidden": {
        "description": "غير مسموح لك بتعديل هذه الرحلة. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
      },
      "success": {
        "description": "تم تعديل الرحلة بنجاح."
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل رحلاتك. يرجى المحاولة مرة أخرى."
    },
    "exportPDF": {
      "all": {
        "button": "تصدير الكل",
        "empty": "لم يتم العثور على رحلات للتصدير.",
        "error": {
          "description": "تعذر تصدير الرحلات إلى PDF. يرجى المحاولة مرة أخرى."
        },
        "success": {
          "description": "تم تصدير جميع الرحلات إلى PDF بنجاح."
        }
      },
      "button": "تصدير إلى PDF",
      "error": {
        "description": "تعذر تصدير الرحلة إلى PDF. يرجى المحاولة مرة أخرى."
      },
      "success": {
        "description": "تم تصدير الرحلة إلى PDF بنجاح."
      }
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض الرحلات. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "generalInformation": "المعلومات العامة",
    "hotel": {
      "hotel": "الفندق",
      "location": {
        "location": "موقع الفندق",
        "placeholder": "رابط خرائط Google"
      },
      "name": {
        "name": "اسم الفندق",
        "placeholder": "اتركه فارغاً إذا لم يكن هناك فندق"
      }
    },
    "id": "المعرف",
    "images": {
      "error": {
        "invalidType": {
          "description": "يرجى اختيار ملفات الصور فقط",
          "title": "نوع الملف غير صالح"
        }
      },
      "new": {
        "description": "يمكنك إرفاق أي عدد من الملفات، يجب ألا يتجاوز كل ملف 10 ميجابايت",
        "title": "اسحب الصور هنا أو انقر للاختيار"
      },
      "title": "الصور"
    },
    "locations": {
      "add": "إضافة موقع",
      "locations": "المواقع",
      "pickValue": "اختر القيمة",
      "create": "إنشاء {{location}}",
      "customSearch": "البحث في المواقع المخصصة...",
      "search": "البحث عن المواقع...",
      "unknownLocation": {
        "description": "يرجى تحديث رحلتك لإصلاح هذه المشكلة.",
        "title": "موقع غير معروف"
      }
    },
    "name": "الاسم",
    "new": "رحلة جديدة",
    "noChangeAfterCreate": "لا يمكن تغييره بعد إنشاء الرحلة",
    "noChangeAfterPublish": "لا يمكن تغييره بعد نشر الرحلة",
    "occupancy": "الإشغال",
    "performance": "الأداء",
    "pricing": {
      "addGroupPricing": "إضافة تسعير المجموعة",
      "childPrice": "سعر الطفل",
      "differentChildPrice": "سعر مختلف للأطفال",
      "groupPricing": "تسعير المجموعة",
      "maxChildDescription": "قم بتحديث الحد الأقصى لعمر الطفل لتمكين هذا الحقل",
      "maximumAgeForChildPrice": "الحد الأقصى لعمر الطفل",
      "minimumNumberOfPeople": "الحد الأدنى لعدد الأشخاص",
      "noGroupPricingAdded": "لم يتم إضافة تسعير للمجموعة",
      "perPerson": "لكل شخص",
      "price": "السعر",
      "pricing": "التسعير",
      "startingPrice": "السعر الابتدائي"
    },
    "revenue": "الإيرادات",
    "save": "حفظ الرحلة",
    "saveAsDraft": "حفظ كمسودة",
    "search": {
      "placeholder": "البحث عن رحلة"
    },
    "selectLocation": "اختر موقعاً",
    "selectTrip": "اختر رحلة",
    "selectTrips": "اختر الرحلات",
    "serial": "تسلسلي",
    "sort": {
      "currentReservations_asc": "أكثر حجوزات",
      "currentReservations_desc": "أقل حجوزات",
      "currentRevenue_asc": "أعلى إيرادات",
      "currentRevenue_desc": "أقل إيرادات",
      "price_asc": "أعلى سعر",
      "price_desc": "أقل سعر",
      "startDate_asc": "الأقدم",
      "startDate_desc": "الأحدث"
    },
    "startsIn": "يبدأ في",
    "status": {
      "COMPLETED": "مكتملة",
      "ONGOING": "جارية",
      "UPCOMING": "قادمة",
      "status": "الحالة"
    },
    "tags": {
      "accessibility": "إمكانية الوصول",
      "adults": {
        "18": "للبالغين فقط (18+)",
        "21": "للبالغين فقط (21+)"
      },
      "airportPickup": "استقبال من المطار",
      "allInclusive": "شامل كل شيء",
      "audience": "الجمهور",
      "breakfastIncluded": "الإفطار متضمن",
      "englishSpeakingGuide": "مرشد يتحدث الإنجليزية",
      "familyFriendly": "مناسب للعائلات",
      "food": "الطعام",
      "freeParking": "موقف مجاني",
      "freeWiFi": "واي فاي مجاني",
      "guidedTour": "جولة مرشدة",
      "guides": "المرشدون",
      "halfBoard": "نصف إقامة",
      "noFood": "لا شيء",
      "petFriendly": "مسموح بالحيوانات الأليفة",
      "tags": "العلامات",
      "transportation": "وسائل النقل",
      "transportationProvided": "وسائل النقل متوفرة",
      "wheelchairAccessible": "مناسب لكرسي متحرك"
    },
    "targetRevenue": "الإيرادات المستهدفة",
    "timeline": "الجدول الزمني",
    "toggleVisibility": {
      "error": {
        "description": "تعذر تحديث رحلتك. يرجى المحاولة مرة أخرى."
      },
      "publish": {
        "success": {
          "description": "تم نشر الرحلة بنجاح"
        },
        "title": "نشر"
      },
      "unpublish": {
        "modal": {
          "description": "الرحلات غير المنشورة لا تزال مرئية للعملاء الذين لديهم حجز. هل أنت متأكد من إلغاء نشر هذه الرحلة؟",
          "title": "إلغاء نشر الرحلة"
        },
        "success": {
          "description": "تم إلغاء نشر الرحلة بنجاح"
        },
        "title": "إلغاء النشر"
      }
    },
    "trip": {
      "empty": {
        "filters": {
          "description": "حاول تعديل المرشحات أو مسحها لعرض جميع الرحلات.",
          "title": "لا توجد رحلات تطابق المرشحات"
        },
        "noFilters": {
          "description": "ابدأ بإنشاء رحلتك الأولى. لن يستغرق الأمر سوى بضع دقائق!",
          "title": "لا توجد رحلات بعد"
        }
      },
      "new": "رحلة جديدة"
    },
    "trips": "الرحلات",
    "view": "عرض الرحلة",
    "visibility": {
      "all": "الكل",
      "draft": "مسودة",
      "draftAlert": {
        "description": "هذه الرحلة لا تزال مسودة وغير منشورة. فقط العملاء الذين لديهم حجز سيكونون قادرين على رؤيتها."
      },
      "published": "منشورة",
      "visibility": "الظهور"
    },
    "yourTrips": "رحلاتك"
  },
  "tryAgain": "حاول مرة أخرى",
  "unknownError": "خطأ غير معروف",
  "unlimited": "غير محدود",
  "unsavedChanges": {
    "description": "لديك تغييرات غير محفوظة. هل أنت متأكد من إغلاق هذا النموذج؟",
    "title": "تغييرات غير محفوظة"
  },
  "withdrawal": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع عمليات السحب.",
        "title": "لا توجد عمليات سحب تطابق المرشحات"
      },
      "noFilters": {
        "description": "لم يتم العثور على عمليات سحب للفترة المحددة.",
        "title": "لا توجد عمليات سحب بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل عمليات السحب. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض عمليات السحب. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "عملية سحب جديدة",
    "title": "عمليات السحب"
  },
  "withdrawals": {
    "empty": {
      "filters": {
        "description": "حاول تعديل المرشحات أو مسحها لعرض جميع عمليات السحب.",
        "title": "لا توجد عمليات سحب تطابق المرشحات"
      },
      "noFilters": {
        "description": "لم يتم العثور على عمليات سحب للفترة المحددة.",
        "title": "لا توجد عمليات سحب بعد"
      }
    },
    "error": {
      "description": "واجهنا خطأ أثناء تحميل عمليات السحب. يرجى المحاولة مرة أخرى."
    },
    "forbidden": {
      "description": "غير مسموح لك بعرض عمليات السحب. اتصل بالمسؤول إذا كنت تعتقد أن هذا خطأ."
    },
    "new": "عملية سحب جديدة",
    "title": "السحوبات"
  },
  "years_or_younger_few": "{{count}} سنة أو أقل",
  "years_or_younger_many": "{{count}} سنة أو أقل",
  "years_or_younger_one": "سنة واحدة أو أقل",
  "years_or_younger_other": "{{count}} سنة أو أقل",
  "years_or_younger_two": "سنتان أو أقل",
  "years_or_younger_zero": "0 سنة أو أقل",
  "yes": "نعم"
}
